<template>
  <section class="bg-ma-gray-0 pt-40 sm:pt-56 -mt-20 sm:-mt-40 pb-20">
    <div class="gr w-full">
      <h2 class="w-full text-center text-2xl md:text-4xl text-ma-black-1 mb-5 md:mb-8 max-w-sm mx-auto leading-8 lg:leading-10">A few examples of common covered usages</h2>
      <div class="w-full md:px-20 md:flex md:flex-wrap">
        <div v-for="(usage, index) in usages" class="w-full md:w-1/2 lg:w-1/3 px-5 py-3 relative" :key="index">
          <div class="bg-ma-black-0 rounded-full absolute h-10 w-10 flex justify-center items-center">
            <img :src="usage.icon" />
          </div>
          <div class="rounded-full bg-white text-ma-gray-3 text-base pl-12 pr-3 h-10 items-center flex">
            <span class="ml-1">{{usage.label}}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  data: () => ({
    usages: [
      {
        icon: "/assets/images/content/license/icon-ads.svg",
        label: "Advertising",
      },
      {
        icon: "/assets/images/content/license/icon-social.svg",
        label: "Social Media Marketing",
      },
      {
        icon: "/assets/images/content/license/icon-company.svg",
        label: "Company Communications",
      },

      {
        icon: "/assets/images/content/license/icon-youtube.svg",
        label: "YouTube + Monetization",
      },
      {
        icon: "/assets/images/content/license/icon-broadcast.svg",
        label: "Broadcast Television",
      },
      {
        icon: "/assets/images/content/license/icon-film.svg",
        label: "Feature Films",
      },

      {
        icon: "/assets/images/content/license/icon-sports.svg",
        label: "Sports Programming",
      },
      {
        icon: "/assets/images/content/license/icon-live.svg",
        label: "Live Events",
      },
      {
        icon: "/assets/images/content/license/icon-non_profit.svg",
        label: "Non-Profit Communications",
      },
    ]
  }),
};
</script>

